import { render, staticRenderFns } from "./ScanForTwo.vue?vue&type=template&id=cc680756&scoped=true"
import script from "./ScanForTwo.vue?vue&type=script&lang=js"
export * from "./ScanForTwo.vue?vue&type=script&lang=js"
import style0 from "./ScanForTwo.vue?vue&type=style&index=0&id=cc680756&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc680756",
  null
  
)

export default component.exports